import React, {useEffect, useState, Fragment, useRef} from 'react'
import SchemaClient from '../../sanity_ecommerce/schemas/client'
import TrueFalseToggle from '../TrueFalseToggle';
import TextField from '../TextField';
import FieldDropdown from '../FieldDropdown';
import {useCreateReplace, useDeleteDocument} from '../../hooks/mutations'
import { addValueForDropdown, removeEmptyProperties, sortByLabel,sortByName } from '../../lib/utils';
import { v4 as uuidv4 } from 'uuid';
import VisDiv from '../frontend_components/VisDiv';
import { successAlert, errorAlert, keyId } from '../../lib/utils';
import { deadlineDataObject } from '../../lib/tableData';
import {useStateContext} from '../../context/StateContext';
import Divider from '../frontend_components/Divider';
import RichTextEditor from '../RichTextEditor';
import Swal from "sweetalert2"
import {AiFillCloseCircle} from 'react-icons/ai';
import SliderRegistriTemplates from '../SliderRegistriTemplates';
import NonConformityPin from '../NonConformityPin';
import {FiEdit} from 'react-icons/fi'

import { richEditorDoc } from '../gestioneDatabase/Docs';


const ManageSchema = ({data, saveFn, archiveFn, selectedDoc=()=>{}}) => {
    const {
        setCustomer,
        sUser,
        LDB,
        setSUser, 
        setLoading,
    } = useStateContext();


    const customerId = sUser?.customer._ref
        
        const {suffix, hide, unique, required, schema, existingDoc, collection, autoFields} = data

        const [docToEdit, setDocToEdit] = useState(existingDoc)
        const [editingSide, setEditingSide] = useState(false)

        const [docId, setDocId] = useState(uuidv4())
       // console.log("IN CONSOLE MANAGE SCHEMA", docToEdit)
        const docType = schema?.name

        const emptyDoc = () => {
            const emptyType = (type) => {
                if (type == "string") return ""
                if (type == "array") return []
                if (type == "object") return {}
                if (type == "reference") return {}
                if (type == "boolean") return false
                if (type == "number") return ""
                if (type == "richTextObject") return richEditorDoc()
                return undefined
            }
            const obj = schema?.fields?.reduce((o, key) => Object.assign(o, {[key?.name]: emptyType(key?.type)}), {})
            return {...obj, _id: uuidv4(), _type: docType, _key: keyId() }

        }
               
        const [doc, setDoc] = useState(docToEdit ? docToEdit : emptyDoc())

        useEffect(()=>{
            const myPromise = new Promise((resolve, reject) => {
                let newDoc = {...doc}
                autoFields?.forEach((item)=>{
                    const field = !Array.isArray(schema?.fields) ? undefined : schema?.fields?.find?.(x=>x?.name == `${item?.schema}`)
                    
                    if(field && field?.type == "reference"){
                        //console.log("IN USE EFFECT REFERENCE:", field);
                        newDoc = {...newDoc, [`${item?.schema}`]:{_ref: item?.referenceId, _type: "reference", _key: keyId()}}
                    }
                    else {
                        //console.log("IN USE EFFECT OPTHER:", field)
                        newDoc = {...newDoc, [`${item?.schema}`]:item?.value}
                    }
                    
                })
                  resolve(newDoc);
      
              }).then((data)=>{
                setDoc(data)
                //console.log("USE EFFECT THEN:", data)
            
            });

            const customerFieldExists = schema?.fields?.some?.(x=>x?.name == "customer")
            if(customerFieldExists){
                setDoc({...doc, customer:{_ref: customerId, _type: "reference", _key: keyId()}})
            }
            
        },[])

        useEffect(()=>{
            

            if(existingDoc){
                let newDoc = {}
                for (var key in doc) {   
                    newDoc = {...newDoc, [key]: existingDoc[key] }
                }
                console.log("useEffectSchemaExistinDoc", newDoc)
                setDoc(newDoc)
                selectedDoc(newDoc)
            }
            else if(docToEdit){
            let newDoc = {}
            for (var key in doc) {   
                newDoc = {...newDoc, [key]: docToEdit[key] }
            }
            //console.log("useEffectSchemaDocToEdit", newDoc)
            setDoc(newDoc)
            selectedDoc(newDoc)
        }
        },[docToEdit, existingDoc])


        const testing = false

        const filteredDoc = (doc, hide) => Object.keys(doc)
        //.filter?.(key => !hide?.some?.(x=>x==key))
        .reduce((obj, key) => {
            return {
            ...obj,
            [key]: doc[key]
            };
        }, {});

        const testFunction = () => {
            
            console.log("doc",doc)
            console.log("emptyDoc",emptyDoc())
            //setDoc(emptyDoc())
            //console.log("COLLECTION", collection) 
            //console.log("doc",removeEmptyProperties(doc))
            console.log("schema", schema)
            //console.log("existingDoc", filteredDoc(doc,hide))
            //console.log("data", data)
            //console.log("errors", error )
        }
        const [error, setError] = useState([])


        const save = () => {
            let errors = []
            for (var key in doc) {
                //========== required data =============
                const isRequired = required?.some?.(y=>y == key)
                //console.log("key in for loop", doc[key])
                if(isRequired) {
                    if(!doc[key]){
                        //console.log(`${key}: ${doc[key]}`)
                        errors.push({key, description:`questo campo è obbligatorio`})
                    }
                    if(doc[key]?._type == "reference" && !doc[key]?._ref){
                        //console.log(`${key}: ${doc[key]}`)
                        errors.push({key, description:`questo campo è obbligatorio`})
                    }
                }
                 //========== unique data =============
                 const uniqueField = !Array.isArray(unique) ? undefined : unique?.find?.(z=>z?.name == key)
                
                 if(uniqueField) {
                    //console.log("unique field", `${key}: ${doc[key]}`, uniqueField)
                    const array = !Array.isArray(uniqueField?.array) ? [] : uniqueField?.array?.filter?.((x)=>{
                        if(docToEdit){
                            const existingField = docToEdit[key]
                            //console.log("EXISTING FIELD",existingField, x)
                            return x.trim()!==existingField.trim()
                        }
                        return x==x
                    })
                    const notUnique = !Array.isArray(array) ? undefined : array?.find?.((f)=>f?.trim() == doc[key]?.trim())
                    if (notUnique){
                        console.log("FIELD IS NOT UNIQUE")
                        errors.push({key, description:`questo campo non è univoco`})
                    }
                 }

                 //========== _ref is empty =============

                 if(!isRequired && doc[key]?._type == "reference" && !doc[key]?._ref){
                    //console.log(`${key}: ${doc[key]}`)
                    errors.push({key, description:`questo campo non è stato caricato correttamente. ricarica e riprova`})
                }

            }
            //console.log("errors",errors)
            setError(errors)


            //========== save data =============

            if(errors?.length>0) {
                //console.log("checks non passati", removeEmptyProperties(filteredDoc(doc, hide)), doc, errors)
            } else {
                //console.log("ready to save", removeEmptyProperties(filteredDoc(doc, hide)), doc)
                saveFn(removeEmptyProperties(filteredDoc(doc, hide)), doc)
                //window.location.reload();
                setDocId(uuidv4())
                setDoc(emptyDoc())
                setDocToEdit(emptyDoc())
                //addDocument({doc: removeEmptyProperties(doc)})
            }

        }
        const archive = () => {
            const archiveDoc  = {
                _id: doc?._id,
                status:"ARCHIVIATO"
            }
            archiveFn(archiveDoc, doc)
            setDocId(uuidv4())
            setDoc(emptyDoc())
            setDocToEdit(emptyDoc())
        }

        const resetFields = () => {
            //console.log("RESET", emptyDoc())
            setDoc(emptyDoc())
            setDocToEdit(emptyDoc())
           // setValue(emptyDoc())
        }

        return(
            <div style={{width:"100%"}}>
                <VisDiv style={{marginBottom:"10px"}} rules={[testing]}><button onClick={testFunction}>Schema Test</button></VisDiv>
                {/* <h1 style={{marginBottom:"10px"}}>{schema?.title}</h1> */}
                <Divider bottom={"12px"}/>
                <VisDiv style={{marginBottom:"12px"}} rules={[true]}>
                    <button className='blue-button' onClick={resetFields}>AZZERA FORM</button>
                </VisDiv>
                <VisDiv rules={[collection]}>
                    <FieldDropdown
                        isMulti={false}
                        isSearchable="isSearchable"
                        initialValue={docToEdit}
                        placeHolder={LDB("misc", "loadDocumentToEdit")}
                        options={addValueForDropdown(collection)?.sort(sortByLabel)}
                        onChange={(value) => {
                            setDocToEdit(value)
                            console.log("DOC TO EDIT dieuwjiduwejd", value)
                            if(value == undefined) {resetFields()}
                        }
                        }
                    />
                </VisDiv>
                <VisDiv style={{display:"flex"}}>
                    <VisDiv style={{flex:1}}>

                        {schema?.fields?.map?.((item, index)=>{
                            const defaultValue = doc[`${item.name}`]
                            //console.log("default value", defaultValue)
                            const [value, setValue] = useState()
                            useEffect(()=>{
                                //console.log("Value IN EFFECT", doc[`${item.name}`])
                                setValue(doc[`${item.name}`])
                                //console.log("SET VALUE IN EFFECT", doc[`${item.name}`])
                            },[doc, docToEdit])
                            //console.log("value", value)                  
                            const suffixSymbol = suffix && ( !Array.isArray(suffix) ? undefined : suffix?.find?.(x=>x?.name == item?.name)?.suffix)
                            const foundError = !Array.isArray(error) ? undefined : error?.find?.(x=>x?.key == item?.name)
                            const errorString = <VisDiv style={{color:"red", marginBottom:"10px", marginTop:"-5px", marginLeft:"3px"}}>{foundError?.description}</VisDiv>

                            const translatedTitle = () => {
                                const title = item?.title
                                if(title == "NomeRegistro") return LDB("schemaTitles", "registerName")
                                return title
                            }
                            if (hide?.some?.((x)=> x == item.name )) return undefined
                            if (item.type == "boolean") return (
                                <Fragment key={index}>
                                    <p>{translatedTitle()}</p>
                                    <TrueFalseToggle
                                        value={value}
                                        onClick={()=>{
                                            console.log(value)
                                            let objCopy = doc
                                            objCopy[`${item.name}`]=!objCopy[`${item.name}`]
                                            setValue(objCopy[`${item.name}`])
                                            setDoc(objCopy)}}
                                    />
                                {errorString}
                                </Fragment>
                            )
                            if(item.type == "string") return (
                                <Fragment key={index}>
                                    <p>{translatedTitle()}</p>
                                    <TextField
                                        defaultValue={value} 
                                        //type="text"
                                        value = {value}
                                        onChange={(e) => {
                                            setValue(e.target.value)
                                            let objCopy = doc
                                            objCopy[`${item.name}`]= e.target.value
                                            setDoc(objCopy)
                                        }}
                                    />
                                {errorString}
                                </Fragment>
                            )
                            if(item.type == "number") return (
                                <Fragment key={index}>
                                    <p>{translatedTitle()}</p>
                                    <div style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
                                        <TextField
                                            defaultValue={value} 
                                            value = {value}
                                            type="number"
                                            onChange={(e) => {
                                                setValue(Number(e.target.value))
                                                let objCopy = doc
                                                objCopy[`${item.name}`]= Number(e.target.value)
                                                setDoc(objCopy)
                                                }
                                            }
                                        />
                                        <p style={{marginLeft:"10px"}}>{suffixSymbol && suffixSymbol}</p>
                                        
                                    </div>
                                    {errorString}

                                </Fragment>
                            )
                            if(item?.type == "reference") {

                                const label = (x) => {
                                    if (x?.label) return x.label
                                    if(x?.family) return x?.family
                                    if (x?.name) return x?.name 
                                    return "NON TROVATO"
                                }
                                if(item?.name == "customer"){
                                    return (undefined)
                                }
                                
                                const options = data?.[`${item?.to[0]?.type}`]?.map?.((obj)=>{
                                    return({
                                        label:label(obj),
                                        value:label(obj),
                                        _id: obj._id
                                    })
                                })
                                //console.log("IN CONSOLE OPTIONS", item)
                                
                                const initialValue1 = () =>{
                                    if(docToEdit){
                                        const defaultOption = !Array.isArray(options) ? undefined : options?.find?.(x=>x?._id == value?._ref)
                                        //console.log("DEFAULT VALUE:",defaultOption, options)
                                        if(!defaultOption) return ({})
                                        return(defaultOption)
                                    }
                                } 
                                return (
                                <Fragment key={index}>
                                    <p>{translatedTitle()}</p>
                                    <FieldDropdown
                                        isSearchable="isSearchable"
                                        initialValue={initialValue1()}
                                        options={options}
                                        onChange={(value) => {
                                            let objCopy = doc
                                            objCopy[`${item.name}`]= {
                                                _ref: value?._id, 
                                                _key: keyId(), 
                                                _type:"reference"
                                            }
                                            setDoc(objCopy)
                                        }}
                                    /> 
                                    {errorString}
                                </Fragment>
                            )}
                            if(item?.type == "array" &&  item?.of[0]?.type == "reference") {

                                const label = (x) => {
                                    if (x?.label) return x.label
                                    if (x?.family) return x?.family
                                    if (x?.name) return x?.name 
                                    return "NON TROVATO"
                                }
                                if(item?.name == "customer"){
                                    return (undefined)
                                }
                                const dataProperty = () => {
                                    const ofExists = item?.of?.length>0 ? true : false
                                    if (!ofExists) return []
                                    if(ofExists){
                                    const toExists = item?.of[0]?.to?.length>0 ? true : false
                                    if (!toExists) return []
                                    if (toExists) return data?.[`${item?.of[0]?.to[0]?.type}`]

                                    }
                                    
                                }
                                const options = dataProperty() ? dataProperty() : [].map?.((obj)=>{
                                    return({
                                        label:label(obj),
                                        value:label(obj),
                                        _id: obj._id
                                    })
                                })
                                //console.log("IN CONSOLE OPTIONS", item)
                                
                                const initialValue1 = () =>{
                                    if(docToEdit){
                                        const defaultOption = !Array.isArray(options) ? undefined : options?.find?.(x=>x?._id == value?._ref)
                                        //console.log("DEFAULT VALUE:",defaultOption)
                                        return(defaultOption)
                                    }
                                } 
                                const toggleEditing = () => {
                                    const editingData = {type: "referenceArray", data: options, propertyName: item?.name}
                                    setEditingSide(editingData)
                                    //console.log("CLICKED TOGGLE",editingData )
                                }
                                const existingList = doc[`${item?.name}`]?.length > 0 ? doc[`${item?.name}`]?.map?.((x)=>{
                                    const findDoc = !Array.isArray(options) ? undefined : options?.find?.((y)=>y?._id == x?._ref)
                                    return findDoc?.label || findDoc?.family || findDoc?.name
                                }) : []
                                return (
                                <Fragment key={index}>
                                    <p>{translatedTitle()}</p>
                                    <button type='button' className='round-back-button' style={{backgroundColor:"red", marginTop:"5px"}} onClick={toggleEditing}>
                                        <FiEdit             
                                        size={15}
                                        color={"white"}/>
                                    </button>
                                    {existingList?.toString()} 
                                    {errorString}
                                </Fragment>
                            )}
                            if(item?.type == "richTextObject") {
                                //console.log("EDITOR DOC", data)
                                const editorDoc = (data) => {
                                   
                                    const richTextDoc = {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}
                                    //const newValue = {...value, richText: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
                                    setValue(richTextDoc)
                                    let objCopy = doc
                                            objCopy[`${item.name}`]= richTextDoc
                                            setDoc(objCopy)
                                    //setLaws([...filteredArray, newValue])
                             
                                }
                                const existingRichTextDoc = () => { 
                                    if(docToEdit?.hasOwnProperty(`${item?.name}`)){ 
                                       return docToEdit[`${item?.name}`]
                                    }
                                    //return richEditorDoc()
                                    
                                 }
                                 //console.log("TESTING EXISTING EDIT", existingRichTextDoc())

                                return(
                                    <div key={index}>
                                        <p>{translatedTitle()}</p>
                                        <RichTextEditor updateInitialData={true} noFocus={true} existingDoc={existingRichTextDoc()} readOnly={false} editorDoc={editorDoc}/>
                                    </div>
                                    )
                            }
                            return(
                                <div key={index}>
                                    <p>{translatedTitle()}</p>
                                    <h3>type not found, create</h3>
                                </div>      
                            )
                        })} 
                    </VisDiv>
                    <VisDiv rules={[editingSide]} style={{flex: 1, borderLeft:"1px solid #c0bfbf", marginLeft:"10px", padding:"10px"}}>
                        <div style={{display:"flex", justifyContent: "flex-end"}}>
                            <button
                                type="button"
                                className="sidebar-close-button"
                                onClick={() => setEditingSide(undefined)}>
                                <AiFillCloseCircle/>
                            </button>
                        </div>
                        <VisDiv rules={[editingSide?.type == "referenceArray"]}>
                            <ArrayReference data={editingSide} closeEditingSide={setEditingSide} doc={doc} setDoc={setDoc} />
                        </VisDiv>
                    </VisDiv>
                 </VisDiv>
                <VisDiv style={{display: "flex", alignItems:"center", justifyContent:"center", marginBottom:"15px"}} className='bottom-buttons'>
                    <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>save()} >
                        {docToEdit?.label ? LDB("misc", "save"): LDB("misc", "addNew")}
                    </button>
                    
                     { docToEdit?.label &&  <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archive()} >
                            {LDB("misc", "archive")}
                        </button>}
                 
                </VisDiv>
            </div> 
        )
    }
export default ManageSchema



export const ArrayReference = ({data, doc, setDoc, closeEditingSide, directSave, fullWidth, hideFilter, disabledIds, dataCallback=()=>{}}) => {
    const {
    customer,
    setLoading,
    LDB,
    registerTemplates
    } = useStateContext();

    const propertyName = data?.propertyName 
    const templates = data?.templates
    const templatesInDocs = doc?.registers
    const expandedTemplatesInDocs = templatesInDocs?.map?.((item)=>{
        const findTemplate = !Array.isArray(templates) ? undefined : templates?.find?.((x)=>x?._id == item?._ref)
        return findTemplate
    })

    const propertiesRefsToFilter = expandedTemplatesInDocs?.map?.((item)=>{
        if(propertyName =="deviceProperties") {
            const expandedDataModules = item?.["fields"]?.map?.((x)=>{
                const findDataModule = !Array.isArray(data?.dataModules) ? undefined : data?.dataModules?.find?.((y)=>y?._id == x?._ref)
                
                return findDataModule?.lists
            }).flat()?.filter?.((x)=>x)

            
            const expandedLists = expandedDataModules?.map?.((z)=>{
                const findList = !Array.isArray(data?.lists) ? undefined : data?.lists?.find?.((t)=>t?._id == z?._ref)
                return findList?.fieldList
            }).flat()?.filter?.((x)=>x)

            //console.log("IN FILTER", expandedLists)

            return expandedLists?.map?.((v)=>({_ref: v?._id}))
        }

        return item?.[propertyName]


    }).flat()?.filter?.((x)=>x)

    const filterFromTemplates = (x) => {

         if(expandedTemplatesInDocs?.length > 0 && templates?.length > 0 && propertyName == "nonConformities"){
            //console.log("IN FILTER", x)
            return x?.registers?.some?.((y)=>templatesInDocs?.some?.((t)=>t?._ref == y?._ref))
         }
            
         if(expandedTemplatesInDocs?.length > 0 && templates?.length > 0) {
            return propertiesRefsToFilter?.some?.((y)=>y?._ref == x?._id) 
        } 
        return x
    }

    const testFunction = () => {
        console.log("DISABLED IDS", disabledIds)
        //console.log("TEST REFERENCE CHECKLIST OK", propertyName, data, propertiesRefsToFilter, expandedTemplatesInDocs)
    }

    const existingList = (doc) => doc[`${propertyName}`]?.length > 0 ? doc[`${propertyName}`]?.map?.((x)=>{
        const findDoc = !Array.isArray(data?.data) ? undefined : data?.data?.find?.((y)=>y?._id == x?._ref)
        return findDoc
    }) : []

    const [list, setList] = useState(existingList(doc))

     useEffect(()=>{
       // console.log("EFFECT IN ARRAY REFERENCE")
        setList(existingList(doc))
    },[doc, data])

    const[registerTemplateFilter, setRegisterTemplateFilter] = useState()
    const[filterTrue, setFilterTrue] = useState(false)

    const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearchNc = (e) => {
        setSearchNcValue(e.target.value);
      };
      const [searchNcValue, setSearchNcValue] = useState("");
      const searchNcRef = useRef();

      const saveList = (list) => {
        const references = list?.map?.((item)=>{
            const reference = {_ref: item?._id ? item?._id : item?._ref, _type: "reference", _key: keyId()}
            return reference
       
        })
        //const newDoc = {...newDoc, [`${item?.schema}`]:{_ref: item?.referenceId, _type: "reference", _key: keyId()}}
        //console.log("TEST DOC", doc, references, "PROPERT NAME", propertyName)
        let objCopy = doc
        objCopy[`${propertyName}`] = references
        setDoc(objCopy)
        //console.log("SAVE LIST", objCopy)
        if(closeEditingSide){
            closeEditingSide(undefined)
        }
 
        //saveReferences(references)
      }
      const editNonConfSearchFilter = (x) => {

        const searchLabel =  x?.label?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        const searchFamily = x?.family?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0
        const searchName = x?.name?.toLowerCase()?.indexOf(searchNcValue.toLowerCase()) >= 0

        const registersArray = x?.registers?.length > 0 ? true : false
        const templatesArray = x?.templates?.length > 0 ? true : false
        const registerArray = x?.register?.length > 0 ? true : false
/*         if(x?._type == "deviceProperty" && registerTemplateFilter){
            console.log("XXXX", x, registerTemplateFilter)
            //const isInTemplate = registerTemplateFilter
            return search
        } */
       // console.log("XXXX", x, registerTemplateFilter)
        if(registersArray && registerTemplateFilter){
            const isRegister = x?.registers?.some?.((x)=> x?._ref == registerTemplateFilter?._id)
            return searchLabel && isRegister
        }
        if(registerArray && registerTemplateFilter){
            const isRegister = x?.register?.some?.((x)=> x?._ref == registerTemplateFilter?._id)
            //console.log("XXXX", x, registerTemplateFilter)
            return searchLabel && isRegister
        }
        if(templatesArray && registerTemplateFilter){
            const isTemplate = x?.templates?.some?.((x)=> x?._ref == registerTemplateFilter?._id)
            return searchLabel && isTemplate
        }

        if(searchFamily) return searchFamily
        //const isRegister = x?.registers?.some?.((y)=> data?.data?.registers?.some?.((z)=>z?._ref == y?._ref))
        if(searchName) return searchName
        //return search && isRegister
        return searchLabel
    }

    const filterWidth = fullWidth ?  {width:"80vw"} : {width:"38vw"}

    const trueFilter = (y) => {
        const isItemInList = list?.some?.((x)=>x?._id == y?._id)
        if(filterTrue){
            return isItemInList
        }
        return y
    }

  return (
    <div>
        <VisDiv rules={[registerTemplates]}>
            <h4>FILTRA DATI ESISTENTI</h4>
            <TrueFalseToggle value={filterTrue} onClick={()=>setFilterTrue(!filterTrue)}/>
            <VisDiv rules={[!hideFilter]}>
            <h4>FILTRA PER FAMIGLIA</h4>
                <div style={{...filterWidth}}>
                    <SliderRegistriTemplates 
                        registerTemplateFilter={registerTemplateFilter} 
                        setRegisterTemplateFilter={setRegisterTemplateFilter} 
                        templates={!Array.isArray(registerTemplates) ? [] : registerTemplates?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                        setLoading={setLoading}
                    />
                </div>
            </VisDiv>

            <div style={{marginBottom:"15px", marginTop:"15px", display:"flex", justifyContent:"center", flexDirection:"column"}}>
                <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
                    <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearchNc} value={searchNcValue} ref={searchNcRef} />
                </div>  
                <VisDiv rules={[!directSave]}>
                    <button type="button" style={{backgroundColor:"green"}} className="btn" onClick={()=>saveList(list)} >{LDB("misc", "save")}</button>
                </VisDiv>
            </div>
            <VisDiv rules={[false]}>
                <button onClick={testFunction}>test array reference</button>
            </VisDiv>
          
            <VisDiv rules={[data?.data?.length>0]}>
                {data?.data
                ?.filter?.(filterFromTemplates)
                ?.filter?.(trueFilter)
                ?.filter?.(editNonConfSearchFilter)
                ?.sort(sortByLabel)
                ?.sort(sortByName)
                ?.map?.((item)=>{
                    //console.log("IN PIN", doc[`${propertyName}`])
                     const itemInList = (list) => list?.find?.((x)=>x?._id == item?._id)
                    const save = (data) => {
                        const dataItem = data?.find?.((x)=>x?._id == item?._id)
                        setList(data)
                        dataCallback(dataItem ? {wasAdded: true, item: dataItem} : {wasAdded: false, item: itemInList(list)})
                        //console.log("data callback iqhjdiquwdh", dataItem)
                        if(directSave){
                            //console.log("DIRECT SAVE", data)
                            saveList(data)
                        }
                    }
                    const isItemInList = (list) => list?.some?.((x)=>x?._id == item?._id)
                   
                    const isPinDisabled = disabledIds?.some?.((x)=>x == item?._id)
                    return (
                    <NonConformityPin
                        pinDisabled = {isPinDisabled}
                        key = {item?._id}
                        label={item?.label || item?.family || item?.name}
                        item={item}
                        array={list}
                        setArray={save}
                        initialValue={isItemInList(list)}
                    />
                    )
                })}
            </VisDiv>

        </VisDiv>
    </div>
  )
}

